import { equals } from "ramda";

function getEnv() {
  if (equals(window.location.host, "app.upserve.com")) {
    return "production";
  }
  if (equals(window.location.host, "app.staging.upserve.com")) {
    return "staging";
  }
  return "development";
}

/**
 * @deprecated use `ENV` constant
 */
export default getEnv;

export type Environment = ReturnType<typeof getEnv>;

export const ENV = getEnv();

export function isDevEnvironment() {
  return ENV === "development";
}
